import { ElectronSDK } from '@/electronSDK';
import { useRef } from 'react';

/* eslint-disable import/prefer-default-export */
export const useOpenDevTools = () => {
  const clickCount = useRef(0);
  const timeout = useRef<any>(null);
  const handleOpenDevTools = () => {
    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }
    clickCount.current += 1;
    timeout.current = setTimeout(() => {
      if (clickCount.current >= 5) {
        // window.electron.ipcRenderer.sendMessage('open-devtools', 'mainWindow');
        ElectronSDK.ipcRenderer.sendMessage('open-devtools', null);
      }
      clickCount.current = 0;
    }, 1000);
  };
  return { handleOpenDevTools };
};
